module.exports = "\n<md-switch \n\tng-model=\"Ctrl.input.data[0].value\" \n\tng-disabled=\"true\"\n\tng-true-value=\"1\" ng-false-value=\"0\"\n\tng-change=\"Ctrl.ngChange()\"\n\taria-label=\"Ctrl.input.label\">\n\t<strong>{{ Ctrl.input.label | translate }}</strong>\n</md-switch>"


//////////////////
// WEBPACK FOOTER
// ./src/components/input-form-view/templates/switch-view.html
// module id = 311
// module chunks = 0